export default __webpack_public_path__ + "static/media/centro_odontologico_microcentro.4457f95a.jpg";